import React, { useEffect } from 'react'
import { Toast } from '@paypalcorp/pp-react'
import PropTypes from 'prop-types'
import { noop } from 'lodash-es'

const ToastWithCallback = ({ onShown = noop, ...props }) => {
  useEffect(() => onShown(), [onShown])
  return <Toast {...props} isSuccess duration={7000} />
}

ToastWithCallback.propTypes = {
  onShown: PropTypes.func,
}

export default ToastWithCallback
